// check more at https://github.com/symfony/symfony/blob/5.x/src/Symfony/Component/HttpFoundation/Response.php#L23
export const HTTP_OK = 200

export const HTTP_UNAUTHORIZED = 401

export const HTTP_INTERNAL_SERVER_ERROR = 500
